import script from "./ExplainContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExplainContent.vue?vue&type=script&setup=true&lang=js"

import "./ExplainContent.vue?vue&type=style&index=0&id=7dee1eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dee1eda"]])

export default __exports__